module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./~/_browserify-sign@4.2.1@browserify-sign/algos.js
// module id = 414
// module chunks = 0